import { ClearSelectedEstimatesAction, estimateSelectionTypes, SetAssignMultipleLoadingAction, SetAssignMultipleModalOpenAction, SetSelectedEstimatesAction, ToggleEstimateSelectionAction } from './types'

const actions = {
  toggleEstimateSelection: (estimateId: string): ToggleEstimateSelectionAction => ({
    type: estimateSelectionTypes.TOGGLE_ESTIMATE_SELECTION,
    payload: estimateId,
  }),
  clearSelectedEstimates: (): ClearSelectedEstimatesAction => ({
    type: estimateSelectionTypes.CLEAR_SELECTED_ESTIMATES,
    payload: null,
  }),
  setSelectedEstimates: (selectedEstimates: string[]): SetSelectedEstimatesAction => ({
    type: estimateSelectionTypes.SET_SELECTED_ESTIMATES,
    payload: selectedEstimates,
  }),
  setAssignMultipleModalOpen: (assignMultipleModalOpen: boolean): SetAssignMultipleModalOpenAction => ({
    type: estimateSelectionTypes.SET_ASSIGN_MULTIPLE_MODAL_OPEN,
    payload: assignMultipleModalOpen,
  }),
  setAssignMultipleLoading: (assignMultipleLoading: boolean): SetAssignMultipleLoadingAction => ({
    type: estimateSelectionTypes.SET_ASSIGN_MULTIPLE_LOADING,
    payload: assignMultipleLoading,
  }),
}

export default actions
